export const PROJECT_STATUS = {
  onHold: 'ON_HOLD',
  onTime: 'ON_TIME',
  done: 'DONE',
  late: 'LATE',
  nonResponsive: 'NON_RESPONSIVE',
  cancelled: 'CANCELLED',
}

export const TASK_TYPE = {
  regular: 'REGULAR',
  event: 'EVENT',
  group: 'GROUP',
}

export const TASK_STATUS = {
  notStarted: 'NOT_STARTED',
  workingOnIt: 'WORKING_ON_IT',
  stuck: 'STUCK',
  signOff: 'SIGN_OFF',
  notScheduled: 'NOT_SCHEDULED',
  scheduled: 'SCHEDULED',
  done: 'DONE',
  notApplicable: 'NOT_APPLICABLE',
}

export const TASK_RESPONSIBILITY = {
  internal: 'INTERNAL',
  customer: 'CUSTOMER',
  thirdParty: 'THIRD_PARTY',
}

export const TASK_VISIBILITY = {
  visible: 'VISIBLE',
  nameOnly: 'NAME_ONLY',
  hidden: 'HIDDEN',
}

export const TASK_PRIORITY = {
  low: 'LOW',
  medium: 'MEDIUM',
  high: 'HIGH',
}

export const USER_PROJECT_CONTEXT = {
  provider: 'PROVIDER',
  customer: 'CUSTOMER',
  thirdParty: 'THIRD_PARTY',
}

export const USER_TASK_CONTEXT = {
  participant: 'PARTICIPANT',
  assignee: 'ASSIGNEE',
}

export const USER_ROLE = {
  superAdmin: 'SUPER_ADMIN',
  admin: 'ADMIN',
  manager: 'MANAGER',
  guide: 'GUIDE',
  contributor: 'CONTRIBUTOR',
  taskOwner: 'TASK_OWNER',
  observer: 'OBSERVER',
}

export const USER_STATUS = {
  activeViaSso: 'active via sso',
  active: 'active',
  pending: 'pending',
  deactivated: 'deactivated',
}

export const ASSIGNEE_MERGE_TAGS = [
  {
    key: 'ASSIGNEE_FIRST_NAME',
    displayName: 'Assignee First Name',
  },
  {
    key: 'ASSIGNEE_LAST_NAME',
    displayName: 'Assignee Last Name',
  },
]

export const INTERNAL_ASSIGNEE_MERGE_TAGS = [
  {
    key: 'ASSIGNEE_CALENDAR_LINK',
    displayName: 'Assignee Calendar Link',
  },
  {
    key: 'ASSIGNEE_MEETING_LINK',
    displayName: 'Assignee Meeting Link',
  },
  ...ASSIGNEE_MERGE_TAGS,
]

export const PM_MERGE_TAGS = [
  {
    key: 'PROJECT_MANAGER',
    displayName: 'Project Manager Name',
  },
  {
    key: 'PROJECT_MANAGER_CALENDAR_LINK',
    displayName: 'Project Manager Calendar Link',
  },
  {
    key: 'PROJECT_MANAGER_MEETING_LINK',
    displayName: 'Project Manager Meeting Link',
  },
]

const BASE_MERGE_TAGS = [
  {
    key: 'CUSTOMER_NAME',
    displayName: 'Customer Name',
  },
  {
    key: 'PROVIDER_NAME',
    displayName: 'Provider Name',
  },
  ...PM_MERGE_TAGS,
]

export const INTERNAL_MERGE_TAGS = [
  ...INTERNAL_ASSIGNEE_MERGE_TAGS,
  ...BASE_MERGE_TAGS,
]

export const EXTERNAL_MERGE_TAGS = [...ASSIGNEE_MERGE_TAGS, ...BASE_MERGE_TAGS]

export const FORM_MERGE_TAGS = [
  {
    slug: 'PROJECT_MANAGER',
    name: 'Project Manager Name',
  },
  {
    slug: 'PROJECT_MANAGER_CALENDAR_LINK',
    name: 'Project Manager Calendar Link',
  },
  {
    slug: 'PROJECT_MANAGER_MEETING_LINK',
    name: 'Project Manager Meeting Link',
  },
]

export const RESPONSIBILITY_TO_ORG_TYPE = {
  INTERNAL: 'PROVIDER',
  THIRD_PARTY: 'THIRD_PARTY',
  CUSTOMER: 'CUSTOMER',
  ALL: 'ALL',
  NOT_IN_PROJECT: 'NOT_IN_PROJECT',
  INTERNAL_IN_PROJECT: 'INTERNAL_IN_PROJECT',
}
